/**
 * Roads Service
 * API operations for the server-backed road autocomplete.
 *
 * Pure service — no React / Zustand. The backend is country-scoped server-side
 * (returns empty items for non-PL workspaces); the `X-Workspace-Id` header is
 * injected by `apiClient`, so no country param is passed here.
 */
import type { AxiosRequestConfig } from 'axios';
import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import type { RoadSearchResponse } from '@/types/api/responses';

/** Query parameters for {@link roadsService.getRoads}. */
export interface GetRoadsParams {
  /** Free-text search over road references (e.g. `A1`, `S7`, `DK1`, `DW305`). */
  search?: string;
  /** 1-indexed page number. */
  page?: number;
  /** Number of suggestions per page. */
  pageSize?: number;
}

export const roadsService = {
  /**
   * Fetch a page of road autocomplete suggestions.
   *
   * @param params - Search + pagination params.
   * @param config - Optional Axios config (e.g. an `AbortController` signal).
   */
  getRoads: (params: GetRoadsParams, config?: AxiosRequestConfig) =>
    apiClient.get<RoadSearchResponse>(API_ENDPOINTS.ROADS.BASE, {
      ...config,
      params,
    }),
};
